import type { ModalData } from '@presentation/components/Modal';

export interface PrebookingWarningModalData {
  modal: ModalData;
  onConfirm(): void;
  proWarning?: string;
  workerServiceWarning?: string;
}

export interface PrebookingWarningModalProps extends PrebookingWarningModalData {}

export interface PrebookingWarningProps
  extends Pick<PrebookingWarningModalData, 'proWarning' | 'workerServiceWarning'> {}
